/* eslint-disable camelcase */
export class QuestionnaireTemplate {
    id: number = -1;
    name: string | undefined;
    questions: number[] = [];
    isDefault = false;

    deserialize(data: any) {
        this.id = data.id ?? -1;
        this.name = data.name ?? '';
        this.questions = data.questions ?? [];
        this.isDefault = data.is_default ?? false;
        return this;
    }

    serialize() {
        return {
            id: this.id,
            name: this.name,
            questions: this.questions,
            is_default: this.isDefault,
        };
    }

    clone() {
        let res = new QuestionnaireTemplate();
        res.id = this.id;
        res.name = this.name;
        res.isDefault = this.isDefault;
        res.questions = [...this.questions];
        return res;
    }

    static Sort(t1: QuestionnaireTemplate, t2: QuestionnaireTemplate): number {
        if (t1.isDefault === t2.isDefault) {
            return t1.name!.localeCompare(t2.name!);
        }
        // Default comes first
        return t1.isDefault ? -1 : 1;
    }
}
